export default {
  userInfo: state => {
    return state.userInfo
  },
  xAuth: state => {
    return state.xAuth
  },
  jssdkEnabled: state => {
    return state.jssdkEnabled
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js